function readFirstStringFromUnknown(value: unknown): string | undefined {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }
  if (Array.isArray(value)) {
    for (const item of value) {
      const nested = readFirstStringFromUnknown(item);
      if (nested) return nested;
    }
  }
  return undefined;
}

/** Extract a user-facing message from common API error response shapes. */
export function readMessageFromData(data: unknown): string | undefined {
  if (typeof data === 'string') {
    return data;
  }

  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (typeof record.message === 'string') return record.message;
    if (typeof record.error === 'string') return record.error;
    if (typeof record.detail === 'string') return record.detail;

    // DRF / Hireport field errors:
    // { name: ["..."] } or { errors: { name: ["..."] } }
    const nameMessage = readFirstStringFromUnknown(record.name);
    if (nameMessage) return nameMessage;

    for (const nestKey of ['errors', 'details'] as const) {
      const nested = record[nestKey];
      if (nested && typeof nested === 'object') {
        const nestedName = readFirstStringFromUnknown(
          (nested as Record<string, unknown>).name,
        );
        if (nestedName) return nestedName;
      }
    }
  }

  return undefined;
}

/** Field-level API error for a given key (DRF / Hireport shape). */
export function readFieldErrorFromData(
  data: unknown,
  field: string,
  depth = 0,
): string | undefined {
  if (!data || typeof data !== 'object' || depth > 4) {
    return undefined;
  }
  const record = data as Record<string, unknown>;
  const direct = readFirstStringFromUnknown(record[field]);
  if (direct) return direct;
  for (const nestKey of ['errors', 'details'] as const) {
    const nested = record[nestKey];
    if (nested && typeof nested === 'object') {
      const nestedField = readFieldErrorFromData(nested, field, depth + 1);
      if (nestedField) return nestedField;
    }
  }
  return undefined;
}
